import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationDeliveryService } from 'src/app/Service/CalibrationDelivery/CalibrationDelivery.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CalibrationDeliveryForm',
  templateUrl: './CalibrationDeliveryForm.component.html',
  styleUrls: ['./CalibrationDeliveryForm.component.scss']
})
export class CalibrationDeliveryFormComponent implements OnInit {

  Procssing: boolean = false;
  FormSubmitted: boolean = false;

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private CalibrationDelivery_Service: CalibrationDeliveryService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
  }

  ResetForm() {
    this.FormSubmitted = false
    this.Info_Delivery_List = []
    this.QRCodeInputDelivery.nativeElement['value'] = ''
  }

  //#region  مشتری
  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  ProcssingCustomer: boolean = false
  modalRef_Customer: any;
  page: number = 0

  Search_CodeName_Customer_Table: string = ''
  Data_Seleted_ReciveCustomer_Dsc: string = ''
  Search_Type_Customer_Table: string = '2'

  DataList_Customer: Array<Customer_List_Interface> = []
  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()


  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }


  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item) {
    this.Data_Seleted_Customer = item
    this.ReadData_Initial_Customer()
    this.modalRef_Customer.hide()
  }

  ReadData_Initial_Customer() {
    this.Customer_Service.GetSingle(this.Data_Seleted_Customer.id).subscribe(
      data => {

        this.DataList_KarshnasMasol = data['karshnasMasol']



      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  //#endregion


  //#region Delivery
  Info_Delivery_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputDelivery') QRCodeInputDelivery: ElementRef;

  QRCodeInputDelivery_Enter() {
    this.Get_Calibration_Info_Delivery(this.QRCodeInputDelivery.nativeElement['value'])
  }

  Get_Calibration_Info_Delivery(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.CalibrationDelivery_Service.GetInfobyQR(this.Data_Seleted_Customer.id, QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDelivery_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")
          }
          else if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده وارد آزمایشگاه نشده است")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده از آزمایشگاه خارج نشده است")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده از تحویل داده شده است")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده مربوط به مشتری " + this.Data_Seleted_Customer.name + " نمی باشد")
          }
          else if (this.Info_Delivery_Exist(data)) {
            this.Alertify_Service.ErrorMessage("QR Code اسکن شده در لیست موجود است")
          }
          else {
            data.dsc = QRCodeInput
            this.Info_Delivery_List.push(data)

            this.Alertify_Service.SuccessMessage("اطلاعات دستگاه خوانده شد")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("QR Code اسکن شده معتبر نمی باشد")

        }
      )
    }

  }

  QRCodeInputDelivery_Esc() {
    this.QRCodeInputDelivery.nativeElement['value'] = ''
  }

  Info_Delivery_Exist(input: General_Interface) {
    for (let item of this.Info_Delivery_List) {
      if (item.code == input.code) {
        return true
      }
    }
    return false
  }

  Info_Delivery_Remove(id: number) {
    this.Info_Delivery_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("حذف شد")
    this.QRCodeInputDelivery.nativeElement.focus();
  }

  //#endregion


  Inperson: string = '-1'
  PersoneType: string = '0'

  InpersoneName: string = ''
  InpersonePhone: string = ''
  InpersoneCodeMeli: string = ''
  InpersoneDsc: string = ''

  CodeRahgiri: string = ''
  KarshnasMasol: string = '0'

  QRCodeChangeDelivery(datepickerInputStart) {

    if (this.Inperson == '1' && this.PersoneType == '0') {
      this.Alertify_Service.ErrorMessage("گیرنده را انتخاب نمائید")
    }
    else if (this.Inperson == '1' && !this.InpersoneName) {
      this.Alertify_Service.ErrorMessage("نام را وارد نمائید")
    }
    else if (this.Inperson == '1' && !this.InpersonePhone) {
      this.Alertify_Service.ErrorMessage("شماره تماس را وارد نمائید")
    }
    else if (this.Inperson == '0' && !this.KarshnasMasol) {
      this.Alertify_Service.ErrorMessage("نماینده کالیبراسیون را انتخاب نمائید")
    }
    else {
      this.Procssing = true

      var Code: Array<string> = []
      for (let item of this.Info_Delivery_List) {
        Code.push(item.dsc)
      }

      this.CalibrationDelivery_Service.SubmitDelivery(
        Code,
        this.Data_Seleted_Customer.id,
        this.Inperson == '1',
        Number(this.PersoneType),
        this.CodeRahgiri,
        datepickerInputStart,
        Number(this.KarshnasMasol),
        this.InpersoneName,
        this.InpersonePhone,
        this.InpersoneDsc,
        this.InpersoneCodeMeli).subscribe(
          data => {

            this.Procssing = false
            this.QRCodeInputDelivery_Esc()
            this.Info_Delivery_List = data

            this.FormSubmitted = true
            this.Alertify_Service.SuccessMessage("دستگاه ها برای تحویل بررسی شد")

          }
        )
    }
  }


}
